var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarWire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 19C4.448 19 4 18.6326 4 18.1818V10H20V18.1818C20 18.6326 19.552 19 19 19H5ZM7 6C7 6.552 7.447 7 8 7C8.553 7 9 6.552 9 6H15C15 6.552 15.447 7 16 7C16.553 7 17 6.552 17 6H19C19.552 6 20 6.449 20 7V8H4V7C4 6.449 4.448 6 5 6H7ZM17 4C17 3.448 16.553 3 16 3C15.447 3 15 3.448 15 4H9C9 3.448 8.553 3 8 3C7.447 3 7 3.448 7 4H5C3.346 4 2 5.346 2 7V18C2 19.654 3.346 21 5 21H19C20.654 21 22 19.654 22 18V7C22 5.346 20.654 4 19 4H17Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWire);
export default __webpack_public_path__ + "static/media/calendar-wire.4fea4d8423ebea61c55f67b0f90edf9f.svg";
export { ForwardRef as ReactComponent };